import { render, staticRenderFns } from "./DuplicateProjectWizard.vue?vue&type=template&id=1aba7225&"
import script from "./DuplicateProjectWizard.vue?vue&type=script&lang=js&"
export * from "./DuplicateProjectWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aba7225')) {
      api.createRecord('1aba7225', component.options)
    } else {
      api.reload('1aba7225', component.options)
    }
    module.hot.accept("./DuplicateProjectWizard.vue?vue&type=template&id=1aba7225&", function () {
      api.rerender('1aba7225', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/DuplicateProjectWizard.vue"
export default component.exports